module.exports = __webpack_public_path__ + "static/media/shark.209c5d10.gif";